import { LinkProps }               from 'react-router-dom';
import { Link as ReactRouterLink } from 'react-router-dom';
import globalModalStore            from '@widesk-ui/stores/globalModalStore';
import useTheme                    from '@widesk-ui/hooks/useTheme';

const Link = (props: LinkProps & { linkSecondary?: boolean }) => {
	const { linkSecondary, ...linkProps } = props;
	const theme = useTheme();

	return (
		<ReactRouterLink
			target={props.target}
			onClick={e => {
				globalModalStore.clear();

				props.onClick?.(e);
			}}
			{...linkProps}
			style={{
				...props.style,
				...(linkSecondary ? { color: theme.colorTextDescription, textDecoration: 'underline' } : {}),
			}}
		/>
	);
};

export default Link;
